export default __webpack_public_path__ + "static/radiant-7a0cb2fd874d1627012b2a4d4d67acc1.jpg";